import { CmpMemberStatusEnum } from "../../../graphql/types";

/**
 * IF11 MB8: the member status values in the design order (CD:16647,
 * DCL "Member list and report status values").
 */
export const CMP_MEMBER_STATUS_OPTIONS: CmpMemberStatusEnum[] = [
  CmpMemberStatusEnum.Active,
  CmpMemberStatusEnum.Pending,
  CmpMemberStatusEnum.Suspended,
  CmpMemberStatusEnum.Cancelling,
  CmpMemberStatusEnum.Cancelled,
  CmpMemberStatusEnum.Deleted,
  CmpMemberStatusEnum.Past,
];

export const cmpMemberStatusLabels: Record<CmpMemberStatusEnum, string> = {
  [CmpMemberStatusEnum.Active]: "Active",
  [CmpMemberStatusEnum.Pending]: "Pending",
  [CmpMemberStatusEnum.Suspended]: "Suspended",
  [CmpMemberStatusEnum.Cancelling]: "Cancelling",
  [CmpMemberStatusEnum.Cancelled]: "Cancelled",
  [CmpMemberStatusEnum.Deleted]: "Deleted",
  [CmpMemberStatusEnum.Past]: "Past",
};
